import { useEffect, useRef }             from "react";
import { Grid }                          from "@gupshup-frontend/gupshup-ts-components";

import { markdown }                      from "./markdownToHtml";
import { sanitizeXSSHtml }               from "./sanitize";
import { PREVIEW_REGEX }                 from "./constant";
import styles                            from "./style.module.css";

const Content = (props) => {

  const {
    content         = "",
    dataTestId      = "",
    isHeaderContent = false,
  } = props;

  const templateContentRef = useRef(null);

  useEffect (() => {
    let __html = getModifiedContent ();
    if (templateContentRef && templateContentRef.current) {
      templateContentRef.current.innerHTML = sanitizeXSSHtml(__html);
    }
  }, [content]);

  const getModifiedContent = () => {
    const modifiedContent = content.replace(PREVIEW_REGEX.BRACKET_REGEX,"");

    return markdown(modifiedContent);
  };

  if(!content) {
    return <></>;
  }

  return (
    <Grid
      ref         = {templateContentRef}
      data-testid = {dataTestId}
      className   = {isHeaderContent ? styles.contentHeader : styles.content}
    >
    </Grid>
  );
};

export default Content;
